function RefreshTokenInterceptor(http, router, store) {
  return function RefreshToken(request, next) {
    next(response => {
      if (response.status !== 401) {
        return null;
      }

      if (response.body && response.body.error === 'invalid_grant') {
        return null;
      }

      store.commit('setBackToPath', router.currentRoute.fullPath);

      return store
        .dispatch('auth/refreshToken')
        .then(() => {
          router.replace(store.state.backToPath);
          return http(request).then(data => data);
        })
        .catch(() => router.push('/sign-in'));
    });
  };
}

export default RefreshTokenInterceptor;
